import { error } from "console";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAddBannerMutation, useAllBannerQuery } from "src/api/bannerAPI";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import ImgInputFile from "src/components/common/imgInputFile";
import { useAppSelector } from "src/store/actions/action";
import { resetRecudeData, setApiData } from "src/store/reducers/fileReduce";
import ErrorParser from "src/utils/jsonParser";
import { createBrowserHistory } from "history";
import styled from "styled-components";

function Banner() {
  // reduce setting 영역
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cHisotry = createBrowserHistory();

  const userInfo = useAppSelector((state) => state.userReduce.userInfo);
  if (userInfo.user_type !== "E") {
    return (
      <>
        <div>본사직원 페이지</div>
      </>
    );
  }

  // Reduce 영역
  const imgFileSaveReduce = useAppSelector((state) => state.fileReduce.imgSaveFiles);

  // API 영역
  const [insertBanner, { isError, isSuccess, error }] = useAddBannerMutation();

  const allBanner = useAllBannerQuery({ skip: true });

  // hook 영역

  useEffect(() => {
    // unmount 명령어와 비슷, component 사라질때 한번 실행
    return () => {
      dispatch(resetRecudeData("reset"));
    };
  }, []);

  useEffect(() => {
    if (allBanner.isSuccess) {
      dispatch(setApiData(allBanner.data.data));
    }
  }, [allBanner.isSuccess]);

  // click event 영역
  const bannerRegiste = () => {
    const form = new FormData();
    for (let i = 0; i < imgFileSaveReduce.length; i++) {
      for (let j = 0; j < imgFileSaveReduce[i]["list"].length; j++) {
        form.append("images", imgFileSaveReduce[i]["list"][j]);
        form.append("brands", imgFileSaveReduce[i]["key"]);
      }
    }

    insertBanner(form);
  };

  useEffect(() => {
    if (isSuccess) {
      navigate("/home");
      dispatch(resetRecudeData("reset"));
    }
    if (isError) {
      const parserDarta = ErrorParser(error);
      alert(parserDarta);
    }
  }, [isSuccess, isError]);

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            배너등록
          </Button>
        </div>
        <div className="btn-box">
          <Button variant="text" onClick={() => bannerRegiste()}>
            등록
          </Button>
        </div>
      </header>

      <Body isTabbar={true}>
        <ListBox>
          {userInfo.brand === "CB" && (
            <>
              MLB <ImgInputFile className="input-file" tagId="M" multipleFlag={false} registeredOneTime="check" />
              <br />
              MLB Kis <ImgInputFile className="input-file" tagId="I" multipleFlag={false} />
              <br />
              Discovery <ImgInputFile className="input-file" tagId="X" multipleFlag={false} />
              <br />
              StretchAngels <ImgInputFile className="input-file" tagId="A" multipleFlag={false} />
              <br />
              Duvetica <ImgInputFile className="input-file" tagId="V" multipleFlag={false} />
              <br />
              Supra <ImgInputFile className="input-file" tagId="W" multipleFlag={false} />
              <br />
              Sergio Tacchini <ImgInputFile className="input-file" tagId="ST" multipleFlag={false} />
              <br />
              공통 <ImgInputFile className="input-file" tagId="CB" multipleFlag={false} />
            </>
          )}
          {userInfo.brand === "M" && (
            <>
              MLB <ImgInputFile className="input-file" tagId="M" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "I" && (
            <>
              MLB Kis <ImgInputFile className="input-file" tagId="I" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "X" && (
            <>
              Discovery <ImgInputFile className="input-file" tagId="X" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "A" && (
            <>
              StretchAngels <ImgInputFile className="input-file" tagId="A" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "V" && (
            <>
              Duvetica <ImgInputFile className="input-file" tagId="V" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "W" && (
            <>
              Supra <ImgInputFile className="input-file" tagId="W" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
          {userInfo.brand === "ST" && (
            <>
              Sergio Tacchini <ImgInputFile className="input-file" tagId="ST" multipleFlag={false} registeredOneTime="check" />
            </>
          )}
        </ListBox>
      </Body>
    </>
  );
}

const ListBox = styled.div`
  padding: 15px;
  font-weight: 700;
`;

export default Banner;
